import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Image from '@iso/assets/images/rob.png';
import IntlMessages from '@iso/components/utility/intlMessages';
import FourZeroFourStyleWrapper from './404.styles';
import { getCookie } from '@iso/lib/helpers/session';
import Forms from "@iso/components/uielements/form";
// import Configs from "../../redux/transactionMgmnt/action";
import { connect } from "react-redux";
import { withRouter } from 'react-router'
const errorMessage = localStorage.getItem('errorMessage');
console.log('errorMessage', errorMessage)
class FourZeroFour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      role: getCookie('role') ? getCookie('role') : null,
      data:false
    }
  }
  componentDidMount() {
    const dashboardData = localStorage.getItem('dashboardData');
    console.log('dashboardData', dashboardData)
    if(dashboardData === 'temp'){
      this.setState({data:true})
    }
}
  render() {
    return (
      <FourZeroFourStyleWrapper className="iso404Page">
        <div className="iso404Content">
          <h1>
            <IntlMessages id="page404.title" />
          </h1>
          {errorMessage === "Link Expired!" || errorMessage === "Access Denied" ? <h3 style={{color: "red"}}>
            {errorMessage}
          </h3>
          :<h3>
            <IntlMessages id="page404.subTitle" />
          </h3>}
          {errorMessage === "Link Expired!" || errorMessage === "Access Denied" ? "":
          <p>
            <IntlMessages id="page404.description" />
          </p>}
          {errorMessage === "Link Expired!" || errorMessage === "Access Denied" ? "":
          <p style={{color: "red"}}>
          {errorMessage}
        </p>}
          <Link to="/">
            <button type="button">
              <IntlMessages id="page404.backButton" />
            </button>
          </Link>
        </div>

        <div className="iso404Artwork">
          <img alt="#" src={Image} />
        </div>
      </FourZeroFourStyleWrapper>
    );
  }
}

const WrappedFormWIthSubmissionButton = withRouter(Forms.create()(FourZeroFour));
export default connect(
    (state) => ({
        state,
        // userResult: state.userManagement.get("data"),
        // result: state.transManagment.get("data"),
        // message: state.transManagment.get("message"),
        // success: state.transManagment.get("success"),
    }),
    {  }
)(WrappedFormWIthSubmissionButton);
localStorage.removeItem('errorMessage');
